import { render } from "./DrawerContainer_Right.vue?vue&type=template&id=1984ffb5"
import script from "./DrawerContainer_Right.vue?vue&type=script&lang=js"
export * from "./DrawerContainer_Right.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__